import {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useWarehouse = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, query) => {
    setLoading(true);
    try {
      const {
        data: {
          content,
          number: page,
          size: pageSize,
          totalElements: pageTotal
        }
      } = await axios.post("/saas/warehouses/search", {
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize,
        ...query
      });
      setData(content);
      return {
        warehouseList: content,
        warehouseListPageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      handleError(error);
      return {
        warehouseList: data,
        warehouseListPageInfo: pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    warehouseListLoading: loading,
    warehouseList: data,
    fetchWarehouseList: fetchData
  };
};
export const useWarehouseModel = createModel(useWarehouse);
